export const accountAbstractionVersion1 = 1;
//# sourceMappingURL=contract.js.map